<button id="chat-audio-input" [ngClass]="recording ? 'recording':'idle'"
    title="Press and hold to record"
  (mousedown)="startRecording()"
  (mouseup)="stopRecording()"
  (mouseleave)="stopRecording()"
><lord-icon src="../../../assets/img/icons/microphone-recording.json" trigger="hover"></lord-icon></button>
